var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShowChart)?_c('BubbleChart',{attrs:{"config":_vm.chartConfig,"width":"100%","height":"100%"},on:{"frame-ended":_vm.setIdle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }